import { createTheme } from "@material-ui/core/styles";

export const temaMenu = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#F0F0F0",
    },
    secondary: {
      main: "#5CDBD3",
      contrastText: "#fff",
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: "4px 8px",
        backgroundColor: "#eaeaea",
      },
    },
    MuiCardHeader: {
      title: {
        fontSize: 18,
      },
    },
  },
});

export default temaMenu;
